import * as React from 'react';

import Table from '~/common/components/Table';
import StyledButton from '~/common/controls/StyledButton';


export default ({ onEdit, onDelete, ...rest }) => {

  const handleEdit = (e, model) => {
    e.preventDefault();
    onEdit(model);
  };

  const handleDelete = (e, model) => {
    e.preventDefault();
    onDelete(model);
  };

  const options = [
    {
      label: 'Delete',
      onClick: (e) => alert('Delete!'),
    },
  ];

  const columns = [
    {
      Header: 'Username',
      accessor: 'username',
    },
    /*
    {
      Header: 'Email',
      accessor: 'email',
    },
    */
    {
      Header: 'Role',
      accessor: 'role',
    },
    {
      Header: 'Name',
      id: 'name',
      accessor: d => `${d.firstName} ${d.lastName}`,
    },
    {
      Cell: (row) => {
        return (
          <StyledButton
            onClick={(e) => handleEdit(e, row.original)}
            label="Edit"
            options={options}
          />
        );
      },
      width: 100,
    },
    // {
    //   Cell: (row) => {
    //     return (
    //       <StyledButton
    //         onClick={(e) => handleDelete(e, row.original)}
    //         label="Delete"
    //         options={options}
    //       />
    //     );
    //   },
    //   width: 100,
    // },
  ];

  return (
    <Table
      columns={columns}
      {...rest}
    />
  );
};
